import React from 'react'
import { Space, Switch, Tooltip } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarCheck } from '@fortawesome/free-solid-svg-icons'

const ScriptingTableControls = ({ type, onlyDue, setOnlyDue, token }) => {
  return (
    <>
      {type === 'schedule' && (
        <Space align='center'>
          <Tooltip title='Toggle to show only scripts that are due'>
            <Space
              align='center'
              style={{
                background: onlyDue ? 'rgba(82, 196, 26, 0.1)' : 'rgba(24, 144, 255, 0.1)',

                borderRadius: '6px',
                border: onlyDue ? '1px solid rgba(82, 196, 26, 0.2)' : '1px solid rgba(24, 144, 255, 0.2)'
              }}
            >
              <FontAwesomeIcon
                icon={faCalendarCheck}
                style={{
                  color: onlyDue ? token.colorSuccess : token.colorTextSecondary,
                  fontSize: 14
                }}
              />
              <span
                style={{
                  color: onlyDue ? token.colorSuccess : token.colorTextSecondary,
                  fontWeight: 500,
                  marginRight: 8
                }}
              >
                Show Due Only
              </span>
              <Switch
                checked={onlyDue}
                onChange={setOnlyDue}
                size='small'
                style={{
                  backgroundColor: onlyDue ? token.colorSuccess : undefined
                }}
              />
            </Space>
          </Tooltip>
        </Space>
      )}
    </>
  )
}

export default ScriptingTableControls
